<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="crt">NOTE: If you purchased this book without a cover, you should be aware that this book is stolen property. It was reported as “unsold and destroyed” to the publisher, and neither the author nor the publisher has received any payment for this “stripped book.”</p>
<p class="crt">This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="crt">EIFELHEIM</p>
<p class="crt">Copyright © 2006 by Michael F. Flynn</p>
<p class="crt">All rights reserved.</p>
<p class="crt">Edited by David G. Hartwell</p>
<p class="crt">Map by Ellisa Mitchell</p>
<p class="crt">A Tor Book<br/>Published by Tom Doherty Associates, LLC<br/>175 Fifth Avenue<br/>New York, NY 10010</p>
<p class="crt"><a class="pubhlink" href="http://www.tor-forge.com" target="_blank">www.tor-forge.com</a></p>
<p class="crt">Tor<sup class="frac">®</sup> is a registered trademark of Tom Doherty Associates, LLC.</p>
<p class="crt">ISBN 978-0-7653-4035-1</p>
<p class="crt">First Edition: October 2006<br/>First Mass Market Edition: August 2009</p>
<p class="crt">Printed in the United States of America</p>
<p class="crt">0 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780765340351_epub_cop_r1.vue?1906e37d